import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as display from '../../../../display'
import * as componentStore from '../component-store'

/**
 * Displays a comparison table as widget content
 */
@ngCore.Component({
  imports: [display.field.Component],
  selector: 'atn-widget-comparison-table',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.ComparisonTable>,
  )
}
